export default __webpack_public_path__ + "static/media/signupimage.98e546ae.png";